export interface HeaderMenuOption {
	content: React.ReactNode;
	title?: string;
	onClick?: () => void;
}
